(function (angular) {
  "use strict";

  angular.module('myApp').component('optionGroupsEdit', {
    templateUrl: '/optionGroups/views/optionGroupEdit.tpl.html',
    controller: [
      '$scope', 'optionGroupService', 'aimEdit',
      function ($scope, optionGroupService, aimEdit) {

      }
    ]
  });

}(window.angular));
